import React from "react";
import PickAndPackProvider from "./PickAndPackProvider";
import ViewBnOrders from "./ViewBnOrders";

const ReviewPurchaseOrdersScreen = () => {
    return <PickAndPackProvider>
        <ViewBnOrders lockedSide="Buy" deliveryStatusFixed="Confirmed" userAction="ReviewPurchaseOrders"/>
    </PickAndPackProvider>
}

export default ReviewPurchaseOrdersScreen